<template>
  <div class="sidebar-resume-block">
    <div class="sidebar-resume-block--title">
      <div class="sidebar-resume-block--title--text">
        {{ title }}
        <vb-icon
          v-if="info"
          :id="`sidebar-resume-block:${title}`"
          :ref="`sidebar-resume-block:${title}`"
          name="info"
          :size="16"
          :color="'#AAA'"
        />
        <b-popover
          v-if="info"
          :target="`sidebar-resume-block:${title}`"
          triggers="hover"
          placement="top"
        >
          <span v-html="info"></span>
        </b-popover>
      </div>
      <div
        v-if="Object.keys(title_content || {}).length > 0"
        class="sidebar-resume-block--title--text"
      >
        <vb-icon
          v-if="title_content.icon"
          v-bind="title_content.icon"
        ></vb-icon>
        <div v-if="title_content.text" class="bold text-content">
          {{ title_content.text }}
        </div>
      </div>
    </div>
    <hr />
    <div class="sidebar-resume-block--body">
      <slot name="default"></slot>
    </div>
    <hr v-if="$slots.footer" />
    <div class="sidebar-resume-block--footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "sidebar-resume-block",
  props: {
    title: String,
    info: {
      type: String,
      default: () => "",
    },
    title_content: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-resume-block {
  hr {
    padding: 0;
    margin: 0;
  }

  display: flex;
  flex-direction: column;

  &--title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--primary);
    margin-bottom: 5px;

    &--text {
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }

  &--body {
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 15px 0;
  }

  &--footer {
    margin-top: 5px;
    width: 100%;
  }
}
</style>
